<script>
  import { handleDistance } from '../../helpers'

  export let selectedInventory
  export let inventories
  export let userCountry

  $: inventory = inventories.find(i => i.skuCode === selectedInventory.skuCode)
</script>

<style>
  p {
    font-size: 12px;
    line-height: 16px;
    color: #484c51;
  }
</style>

{#if selectedInventory.isVip}
  <p data-test="inventory-benefits">
    Includes 150 {handleDistance(userCountry)} of towing for all household vehicles
  </p>
{:else if inventory && inventory.id}
  <p data-test="inventory-benefits">
    Your Hagerty Driver Club membership includes roadside service at {inventory.benefits.roadside.towingDistance} {handleDistance(userCountry)}
    per tow for your {inventory.benefits.roadside.vehiclesCovered} vehicles.
  </p>
{/if}
